import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
// import { PersistGate } from 'redux-persist/integration/react';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import App from './app';
import { I18nProvider } from './locales';
import { routesSection } from './routes/pages';
import { ErrorBoundary } from './routes/components';
import {
  store,
  // persistor
} from './redux/store';
import { CallProvider } from './pages/chat/channel/call/hooks/call-provider';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = createRoot(document.getElementById('root')!);

root.render(
  // <StrictMode>
  <Provider store={store}>
    {/* <PersistGate loading={<h1>Loading...</h1>} persistor={persistor}> */}
    <HelmetProvider>
      <CallProvider>
        <I18nProvider>
          <RouterProvider router={router} />
        </I18nProvider>
      </CallProvider>
    </HelmetProvider>
    {/* </PersistGate> */}
  </Provider>
  // </StrictMode>
);
